import React, { useState, useEffect, useRef } from "react";
import "./NavBar.css";
import solarLogo from '../../../assets/images/logo/solar-logo.png'
import { NavLink } from "react-router-dom";
import { fetchData } from "../utils";
import { countryListLocal } from "../../CountryList";
const NavBar = () => {
  const [categories, setCategories] = useState(['E Bikes']);
  const [logosByCategory, setLogosByCategory] = useState({ 'E Bikes': [] });
  const [modal, setModal] = useState(false);
  const [categoryList, setCategoryList] = useState([]);
  const [servicesList, setServicesList] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState('PK')
  const offcanvasRef = useRef();
  const countrylist = countryListLocal.item.sort((a, b) => a.name.common.localeCompare(b.name.common));


  useEffect(() => {
    const fetchApiData = async () => {
      const url = "api/company/logo";
      const result = await fetchData(url);
      const bikeList = await fetchBikeData();
      if (result && result.data) {
        result.data = result.data.filter(item => item.title !== 'E-Bikes')
        const categorizedLogos = {
          'E Bikes': [],
        };
        setCategoryList(result.data)
        //   result.data.forEach((item) => {
        //     const categoryTitle = item.title;
        //     if (!categorizedLogos[categoryTitle]) {
        //       categorizedLogos[categoryTitle] = [];
        //     }
        //     categorizedLogos[categoryTitle]=item.company_logos.map((item) => ({
        //   id: item.id ,
        //   img: item.media[0]?.original_url,
        //   slug:'',
        //   companyName: item.title,
        // }));
        //   });

        categorizedLogos["E Bikes"] = bikeList.map((bike) => ({
          id: bike.id,
          img: bike.media[0]?.original_url,
          slug: bike?.slug,
          companyName: bike.title,
        }));
        setCategories(Object.keys(categorizedLogos));
        setLogosByCategory(categorizedLogos);
      }
    };
    fetchServicesData()
    fetchApiData();
  }, []);
  const fetchBikeData = async () => {
    const url = "api/bike/logo";
    const result = await fetchData(url);
    if (result && result.status === true) {
      return result.data;
    }
  };
  const fetchServicesData = async () => {
    const url = "api/service";
    const result = await fetchData(url);
    if (result && result.status === true) {
      setServicesList(result.data);
    }
  };
  const handleNavLinkClick = () => {
    if (offcanvasRef.current) {
      offcanvasRef.current.click();
    }
  };
  const toggleCountry = () => setModal(!modal);
  const HandleCountry = (value) => {
    setSelectedCountry(value);
    setModal(false)
  }
  // console.log(categories);
  
  return (
    <>
      {/* <Modal isOpen={modal} toggle={toggleCountry} size="xl">
        <ModalHeader>Select Country</ModalHeader>
        <ModalBody>
          <div className="row">
            {countryListLocal.item.sort((a, b) => a.name.common.localeCompare(b.name.common)).map((item, index) => (
              <div key={index} className={`col-md-3 country-list  mt-2 ${selectedCountry === item.cca2 ? 'text-danger fw-bold' : ''} `}>
                <div onClick={() => HandleCountry(item.cca2)}>{item.name.common}</div>
              </div>
            ))}
          </div>
        </ModalBody>
        <ModalFooter>
          <button type="button" onClick={toggleCountry} className="btn btn-danger">Close</button>
        </ModalFooter>
      </Modal> */}
      <div class="modal fade bd-example-modal-lg" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            ...
          </div>
        </div>
      </div>
      <section className="container-fluid theme-color py-2">
        <header className="container d-flex justify-content-between mobile-top-bar align-items-center flex-wrap">
          {/* <!-- social icons --> */}
          <div className="d-flex   header-sicials">
            <a href="https://www.facebook.com/share/16zrYVth6P/?mibextid=wwXIfr" target="_blank"><i style={{fontSize:'20px'}} className="bi bi-facebook  social-icons"></i></a>
            <a href="https://youtube.com/@energybazzar?si=52HeyIF87lkgEA1E" target="_blank"><i style={{fontSize:'20px'}} className="bi bi-youtube  social-icons"></i></a>
            <a href="https://www.instagram.com/energy_bazzar/profilecard/?igsh=MWdpNWFsaHkyOGhiNg==" target="_blank"><i style={{fontSize:'18px'}} className="bi bi-instagram  social-icons"></i></a>
             <a href="https://x.com/energybazzar?s=21" target="_blank"><i style={{fontSize:'18px'}} className="bi bi-twitter-x  social-icons"></i></a>
             <a href="https://wa.me/message/ZS2DVQ6CORCXO1" target="_blank"><i style={{fontSize:'18px'}} className="bi bi-whatsapp  social-icons"></i></a>
          </div>
          {/* <!-- signup or sign in button --> */}
          <div className="d-flex justify-content-center align-items-center gap-3">
            {/* <button
              onClick={toggleCountry}
              className="btn btn-outline-light btn-sm"
            >
              {selectedCountry}
            </button> */}
            <NavLink to="/register" >
              <button
                className="btn btn-outline-light btn-sm"
              >
                Sign up
              </button>
            </NavLink>
            <div className="vr d-none d-md-block"></div>
            <NavLink to="/login" >
              <button
                className="btn btn-outline-light btn-sm"
              >
                Sign In
              </button>
            </NavLink>

          </div>
        </header>
      </section>
      <nav className="navbar navbar-expand-lg bg-light bsb-navbar bsb-navbar-hover bsb-navbar-caret">
        <div className="d-flex justify-content-between align-items-center w-100 px-5 flex-wrap">
          <NavLink className="navbar-brand" to="/">
            <img
              src={solarLogo}
              alt="Energy Bazzar Logo"
              width="135"
              height="44"
            />
          </NavLink>
          <button
            className="navbar-toggler border-0 text-end w-fit"
            type="button"
            data-bs-toggle="offcanvas"
            data-bs-target="#offcanvasNavbar"
            aria-controls="offcanvasNavbar"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              fill="currentColor"
              className="bi bi-list"
              viewBox="0 0 16 16"
            >
              <path
                fillRule="evenodd"
                d="M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5z"
              />
            </svg>
          </button>
          <div

            className="offcanvas offcanvas-end"
            tabIndex="-1"
            id="offcanvasNavbar"
            aria-labelledby="offcanvasNavbarLabel"
          >
            <div className="offcanvas-header">
              <h5 className="offcanvas-title" id="offcanvasNavbarLabel">
                Menu
              </h5>
              <button
                type="button"
                ref={offcanvasRef}
                className="btn-close"
                data-bs-dismiss="offcanvas"
                aria-label="Close"
              ></button>
            </div>
            <div className="offcanvas-body">
              <ul className="navbar-nav justify-content-center fw-bold flex-grow-1">
                 {categories.map((item, index) => (
                  <li key={index} className="nav-item dropdown ">
                    <NavLink
                      className="nav-link  dropdown-toggle"
                      to={item.toLowerCase() === 'e bikes' ? '/e-bikes' : item.toLowerCase() === 'solar' ? '/solar' : '/'}
                    >
                      {item}
                    </NavLink>
                    <ul
                      className="dropdown-menu border-0 shadow bsb-zoomIn mega-menu-solar-penal"
                      aria-labelledby="accountDropdown"
                    >
                      <div className="row px-3 my-3">
                        {logosByCategory[item]?.slice(0, 7).map((details, index) => (
                          <div className="col-xl-4 col-lg-4 col-md-6 mt-2 col-sm-12 col-xs-12 m-0">

                            <NavLink
                              onClick={handleNavLinkClick}
                              to={item.toLowerCase() === 'electronics' ? `electronics/${details.slug}` : item.toLowerCase() === 'solar' ? `solar/${details.slug}` : item.toLowerCase() === 'e bikes' ? `e-bikes/${details.slug}` : `${item.slug}/${details.slug}`} className="text-secondary text-decoration-none" >
                              <i className="bi bi-sun me-2"></i>{details?.companyName}
                            </NavLink>
                          </div>
                        ))}
                        {logosByCategory[item]?.length > 6 && (
                          <div className="col-xl-4 col-lg-4 col-md-6 mt-2 col-sm-12 col-xs-12 m-0">
                            <NavLink
                              onClick={handleNavLinkClick}
                              to={item.toLowerCase() === 'e bikes' ? '/e-bikes' : '/'} className="text-danger text-decoration-none fw-bold" >
                              <i className="bi bi-arrow-right me-2"></i> View All
                            </NavLink>
                          </div>
                        )}
                      </div>
                      <div className="row px-5 my-1">
                        <p className="fw-bold mt-3">Explore</p>
                        {item === 'E Bikes'  && (
                          <div className="col-xl-6 col-lg-6 col-md-6 mb-2 col-sm-12 col-xs-12 m-0">
                            <NavLink
                              onClick={handleNavLinkClick}
                              to={item === 'E Bikes' ? '/e-bikes' : item === 'E-Vehicles' ? 'e-vehicles' : '/'} className="text-secondary text-decoration-none" >
                              <i className="bi bi-sun me-2"></i>Find {item === 'E Bikes' ? 'Bikes' : item === 'E-Vehicles' ? 'E Vehicles' : ''}
                            </NavLink>
                          </div>
                        )}
                        {item === 'E Bikes' && (
                          <div className="col-xl-6 col-lg-6 col-md-6 mb-2 col-sm-12 col-xs-12 m-0">
                            <NavLink
                              onClick={handleNavLinkClick}
                              to='/comparison' className="text-secondary text-decoration-none" >
                              <i className="bi bi-sun me-2"></i>{item === 'E Bikes' ? 'Bikes' : item === 'E-Vehicles' ? 'E Vehicles' : ''} Comparisons
                            </NavLink>
                          </div>
                        )}
                        <div className="col-xl-6 col-lg-6 col-md-6 mb-2 col-sm-12 col-xs-12 m-0">
                          <NavLink
                            onClick={handleNavLinkClick}
                            to='/find-service-providers' className="text-secondary text-decoration-none" >
                            <i className="bi bi-sun me-2"></i>Find Dealers/Service Providers
                          </NavLink>
                        </div>
                      </div>
                    </ul>
                  </li>
                ))}

                {categoryList.map((item, index) => (
                  <li key={index} className="nav-item dropdown ">
                    <NavLink
                      className="nav-link  dropdown-toggle"
                      to={`/${item.slug}`}
                    >
                      {item.title}
                    </NavLink>
                    <ul
                      className="dropdown-menu border-0 shadow bsb-zoomIn mega-menu-solar-penal"
                      aria-labelledby="accountDropdown"
                    >
                      <div className="row px-3 my-3">
                        {item.company_logos.slice(0, 7).map((details, index) => (
                          <div key={index} className="col-xl-4 col-lg-4 col-md-6 mt-2 col-sm-12 col-xs-12 m-0">

                            <NavLink
                              onClick={handleNavLinkClick}
                              to={item.title.toLowerCase() === 'electronics' ? `electronics/${details.slug}` : item.title.toLowerCase() === 'solar' ? `solar/${details.slug}` : item.title.toLowerCase() === 'e bikes' ? `e-bikes/${details.slug}` : `${item.slug}/${details.slug}`} className="text-secondary text-decoration-none" >
                              <i className="bi bi-sun me-2"></i>{details?.title}
                            </NavLink>
                          </div>
                        ))}
                        {item.company_logos.length > 6 && (
                          <div className="col-xl-4 col-lg-4 col-md-6 mt-2 col-sm-12 col-xs-12 m-0">
                            <NavLink
                              onClick={handleNavLinkClick}
                              to={`/${item.slug}`} className="text-danger text-decoration-none fw-bold" >
                              <i className="bi bi-arrow-right me-2"></i> View All
                            </NavLink>
                          </div>
                        )}
                        <div className="row my-1">
                          <p className="fw-bold mt-3">Explore</p>
                            <div className="col-xl-6 col-lg-6 col-md-6 mb-2 col-sm-12 col-xs-12 m-0">
                              <NavLink
                                onClick={handleNavLinkClick}
                                to={item.title === 'E Bikes' ? '/e-bikes' : item.title === 'E-Vehicles' ? 'e-vehicles' : `/${item.slug}`} className="text-secondary text-decoration-none" >
                                <i className="bi bi-sun me-2"></i>Find {item.title === 'E Bikes' ? 'Bikes' : item.title === 'E-Vehicles' ? 'E Vehicles' : item.title}
                              </NavLink>
                            </div>
                            <div className="col-xl-6 col-lg-6 col-md-6 mb-2 col-sm-12 col-xs-12 m-0">
                              <NavLink
                                onClick={handleNavLinkClick}
                                to='/comparison' className="text-secondary text-decoration-none" >
                                <i className="bi bi-sun me-2"></i>{item.title === 'E Bikes' ? 'Bikes' : item.title === 'E-Vehicles' ? 'E Vehicles' : item.title} Comparisons
                              </NavLink>
                            </div>
                          <div className="col-xl-6 col-lg-6 col-md-6 mb-2 col-sm-12 col-xs-12 m-0">
                            <NavLink
                              onClick={handleNavLinkClick}
                              to='/find-service-providers' className="text-secondary text-decoration-none" >
                              <i className="bi bi-sun me-2"></i>Find Dealers/Service Providers
                            </NavLink>
                          </div>
                        </div>
                      </div>
                    </ul>
                  </li>
                ))}
               
                <li className="nav-item dropdown ">
                  <a
                    className="nav-link  dropdown-toggle"
                  >
                    E-Shops
                  </a>
                  <ul
                    className="dropdown-menu border-0 shadow bsb-zoomIn mega-menu-solar-penal"
                    aria-labelledby="accountDropdown"
                  >
                    <div className="row px-5 my-3">
                       <div className="col-xl-6 col-lg-6 col-md-6 mt-2 col-sm-12 col-xs-12 m-0">
                        <NavLink
                          onClick={handleNavLinkClick}
                          to='/products' className="text-secondary text-decoration-none" >
                          <i className="bi bi-sun me-2"></i>EnergyBazzar Store
                        </NavLink>
                      </div>
                       <div className="col-xl-6 col-lg-6 col-md-6 mt-2 col-sm-12 col-xs-12 m-0">
                        <NavLink
                          onClick={handleNavLinkClick}
                          to='/ad' className="text-secondary text-decoration-none" >
                          <i className="bi bi-sun me-2"></i>Deals & Ads
                        </NavLink>
                      </div>
                       <div className="col-xl-6 col-lg-6 col-md-6 mt-2 col-sm-12 col-xs-12 m-0">
                        <NavLink
                          onClick={handleNavLinkClick}
                          to='/login' className="text-secondary text-decoration-none" >
                          <i className="bi bi-sun me-2"></i>Sell with us
                        </NavLink>
                      </div>
                    </div>
                  </ul>
                </li>
                <li className="nav-item dropdown ">
                  <a
                    className="nav-link  dropdown-toggle"
                  >
                    Energy talks
                  </a>
                  <ul
                    className="dropdown-menu border-0 shadow bsb-zoomIn mega-menu-solar-penal"
                    aria-labelledby="accountDropdown"
                  >
                    <div className="row px-3 my-3">
                      <div className="col-xl-4 col-lg-4 col-md-6 mt-2 col-sm-12 col-xs-12 m-0">

                        <NavLink
                          onClick={handleNavLinkClick}
                          to='/blogs' className="text-secondary text-decoration-none" >
                          <i className="bi bi-sun me-2"></i>Blogs
                        </NavLink>
                      </div>
                      <div className="col-xl-4 col-lg-4 col-md-6 mt-2 col-sm-12 col-xs-12 m-0">
                        <NavLink
                          onClick={handleNavLinkClick}
                          to='/faqs' className="text-secondary text-decoration-none" >
                          <i className="bi bi-sun me-2"></i>Faqs
                        </NavLink>
                      </div>
                      <div className="col-xl-4 col-lg-4 col-md-6 mt-2 col-sm-12 col-xs-12 m-0">
                        <NavLink
                          onClick={handleNavLinkClick}
                          to='/all-videos' className="text-secondary text-decoration-none" >
                          <i className="bi bi-sun me-2"></i>Videos
                        </NavLink>
                      </div>
                      
                    </div>
                  </ul>
                </li>
                <li className="nav-item">
                  <NavLink onClick={handleNavLinkClick} className="nav-link" to="/about-us">
                    About Us
                  </NavLink>
                </li>
                {/* <NavLink className='mobile-services mt-1' to='/our-services'>
                  <button
                    className="btn btn-outline-danger btn-danger text-white fw-bold btn-sm"
                  >
                    Our Services
                  </button>
                </NavLink> */}
                <div className="services-dropdownMobile">
                  <NavLink onClick={handleNavLinkClick} className="services-dropdown-btn-wrap mobile-services" to="/our-services">
                    <button className=" btn btn-outline-danger btn-danger text-white fw-bold btn-sm">
                      Our Services
                    </button>
                  </NavLink>

                  <ul className="services-dropdown-menu">
                    {servicesList.map((item, index) => (
                      <li key={index}><NavLink onClick={handleNavLinkClick} to={`/our-services/${item?.slug}`}>{item?.title}</NavLink></li>
                    ))}

                  </ul>
                </div>
              </ul>
            </div>
          </div>
          {/* <NavLink className='services-button' to='/our-services'>
            <button
              className="btn btn-outline-danger btn-danger text-white fw-bold btn-sm"
            >
              Our Services
            </button>
          </NavLink> */}
          <div className="services-dropdown">
            <NavLink className="services-dropdown-btn-wrap" to="/our-services">
              <button className=" btn btn-outline-danger btn-danger text-white fw-bold btn-sm">
                Our Services
              </button>
            </NavLink>

            <ul className="services-dropdown-menu">
              {servicesList.map((item, index) => (
                <li key={index}><NavLink to={`/our-services/${item?.slug}`}>{item?.title}</NavLink></li>
              ))}

            </ul>
          </div>
        </div>
      </nav>
    </>
  );
};

export default NavBar;
